var render = function render(){var _vm=this,_c=_vm._self._c;return _c('card',{staticClass:"no-border-card card-instructions"},[_c('template',{slot:"header"},[_c('h3',[_vm._v("Additional Notes")])]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.recipeData.notes)}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }